import { getWorkbenchList, getWorkbenchDetailInfo } from "@/api/workbench";

export default {
  namespace: "workbench",
  state: {
    workbenchList: [],
    currentSelectedWorkbench: {},
    cardAccessTokenList: [],
    workbenchDetail: null,
    isLoadJs: false
  },
  reducers: {
    setWorkbenchList(state: any, { payload }: { payload: any }) {
      return { ...state, ...payload };
    },
    setCardAccessTokenList(state: any, { payload }: { payload: any }) {
      return { ...state, ...payload };
    },
    setWorkbenchDetail(state: any, { payload }: { payload: any }) {
      return { ...state, ...payload };
    },
    setIsLoadJs(state: any, { payload }: { payload: any }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *getWorkbenchList({ payload }: any, { call, put }: any): any {
      let { localstorageKey } = payload;
      const { workbenches } = yield call(getWorkbenchList);
      if (!workbenches || (workbenches && workbenches.length === 0)) {
        yield put({
          type: "setWorkbenchList",
          payload: {
            workbenchList: [],
            currentSelectedWorkbench: { workBenchType: 1 }
          }
        });
      } else {
        let historySelectedWorkbenchObj: any = null;
        let isUseHistorySelectedWorkbench = false;
        let historySelectedWorkbenchString = window.localStorage.getItem(
          "currentSelectedWorkbench"
        );
        let workbencheInfo: any = null;
        if (historySelectedWorkbenchString) {
          historySelectedWorkbenchObj = JSON.parse(historySelectedWorkbenchString)[localstorageKey];
        }
        if (historySelectedWorkbenchObj) {
          workbencheInfo = workbenches.find((workbenche: any) => {
            return workbenche.workBenchId === historySelectedWorkbenchObj.workBenchId;
          });
          if (workbencheInfo) {
            isUseHistorySelectedWorkbench = true;
          }
        }
        yield put({
          type: "setWorkbenchList",
          payload: {
            workbenchList: workbenches,
            currentSelectedWorkbench: isUseHistorySelectedWorkbench
              ? workbencheInfo
              : workbenches[0]
          }
        });
      }
    },
    *getWorkbenchDetailInfo({ payload }: any, { call, put }: any): any {
      const { workbenchDetailDto } = yield call(getWorkbenchDetailInfo, payload);
      yield put({
        type: "setWorkbenchDetail",
        payload: {
          workbenchDetail: workbenchDetailDto
        }
      });
    }
  }
};
